import { render, staticRenderFns } from "./DeleteTest.vue?vue&type=template&id=13212706"
import script from "./DeleteTest.vue?vue&type=script&lang=js"
export * from "./DeleteTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports